import { html } from '../lib/html.js';
import { icon } from '../lib/icons.js';

// Bottom sheet on phones, centred dialog on larger screens. Built on <dialog>
// so focus trapping, Escape and the backdrop come from the platform.
export function openSheet({ title, body, foot = '', className = '', onClose, labelledBy } = {}) {
  const dialog = document.createElement('dialog');
  dialog.className = `sheet ${className}`;
  const titleId = labelledBy || `sheet-title-${Math.random().toString(36).slice(2, 8)}`;
  dialog.setAttribute('aria-labelledby', titleId);
  dialog.innerHTML = String(html`
    <div class="sheet__grab" aria-hidden="true"></div>
    <div class="sheet__head">
      <h2 class="sheet__title" id="${titleId}">${title}</h2>
      <button type="button" class="icon-btn sheet__close" data-sheet-close aria-label="Close">${icon('close')}</button>
    </div>
    <div class="sheet__body">${body}</div>
    ${foot ? html`<div class="sheet__foot">${foot}</div>` : ''}`);
  document.body.appendChild(dialog);
  const close = (value) => {
    if (dialog.open) dialog.close(value === undefined ? '' : String(value));
  };
  dialog.addEventListener('click', (e) => {
    if (e.target === dialog) close();
    if (e.target.closest('[data-sheet-close]')) close();
  });
  dialog.addEventListener('close', () => {
    if (onClose) onClose(dialog.returnValue);
    setTimeout(() => dialog.remove(), 0);
  });
  dialog.showModal();
  return { el: dialog, close };
}

export function confirmDialog({ title, message, confirm = 'Confirm', cancel = 'Cancel', danger = false }) {
  return new Promise((resolve) => {
    let answered = false;
    const { el, close } = openSheet({
      title,
      body: html`<p class="muted">${message}</p>`,
      foot: html`
        <button type="button" class="btn btn--secondary" data-sheet-close>${cancel}</button>
        <button type="button" class="btn ${danger ? 'btn--solid-danger' : 'btn--primary'}" data-confirm>${confirm}</button>`,
      onClose: () => {
        if (!answered) resolve(false);
      },
    });
    el.querySelector('[data-confirm]').addEventListener('click', () => {
      answered = true;
      resolve(true);
      close();
    });
  });
}
